// this file is generated by update_shopify_store_data.py at 2026-03-18 20:24:10.533612
var courses = [
    {
        "course_id": "954A80DC-2F27-EF11-998C-005056A7B953",
        "course_version": 3,
        "name": "Rapid Regs for Practitioners (Chicago Employees Only)",
        "course_type": 32,
        "author_information": "",
        "description": "As an important component of a good healthcare compliance program, HealthStream\u2019s expert onboarding and annual training, ensures your physicians understand how to comply with federal laws and avoid activity that could lead to potential risk, liability, and administrative action. This curriculum is designed for practitioners in Chicago who are NOT Managers/Supervisors.\r\n\r\nThese courses can be completed in one sitting if time permits or over the course of several learning sessions. Where available, the learner may achieve pre-assessment test-out.",
        "learning_objectives_html": "At the conclusion, participants should be able to:",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "1C55AE96-3224-EF11-9994-005056A716EA",
                "course_category_name": "HSTM - Rapid Regs for Practitioners - Curricula",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": [
            {
                "course_id": "1E05255A-B8D0-EE11-998B-005056A721AC",
                "course_version": 4,
                "name": "SQ Acute: Abuse and Neglect (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This module helps learners recognize and understand the different types of abuse, the signs of abuse, and the reporting requirements of suspected or confirmed abuse.",
                "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>Define abuse </li>\r\n    <li>Identify types of abuse and related signs and symptoms.\r\n    </li>\r\n    <li>    Describe actions to take to protect individuals from abuse. </li>\r\n    <li> Describe the reporting requirements for suspected or confirmed abuse.\r\n    </li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "55C9834D-0286-E811-9579-005056B150D1",
                        "course_category_name": "Hospice",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3F4D9D32-F3FD-E611-BC44-005056B10E33",
                        "course_category_name": "Correctional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "zRemoved-Medical Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C6B37F61-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Rehabilitation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "51FB57AE-C98C-EB11-80DF-005056B134EC",
                        "course_category_name": "Intimate Partner Violence",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "57DADFC8-E203-E911-A43F-005056B13721",
                        "course_category_name": "Sexual Abuse & Assault",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A0CBF9A6-C98C-EB11-80DF-005056B134EC",
                        "course_category_name": "Child Abuse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4A566AD5-0186-E811-A5DD-005056B150D3",
                        "course_category_name": "Pain",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0A2A275A-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0BB4475A-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Gerontology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FA20BE9F-C98C-EB11-80DF-005056B134EC",
                        "course_category_name": "Elder Abuse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9E2202A8-0386-E811-ABAD-005056B17F80",
                        "course_category_name": "School",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DA6A4541-D28C-EB11-80DF-005056B134EC",
                        "course_category_name": "Mandatory Reporting",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "56EBAE7E-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Home Healthcare",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B0FAB4D3-9106-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Abuse and Neglect",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                        "course_category_name": "zRemoved-Cardiovascular Perfusionist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7064D866-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "957F716A-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Infusion Therapy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E23CFC1B-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Dialysis",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "A15EF888-B9D0-EE11-998B-005056A721AC",
                "course_version": 2,
                "name": "SQ Acute: Adverse Drug Events (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This module helps learners recognize adverse events, distinguish their severity, and identify populations at risk.",
                "learning_objectives_html": "<p>Upon the completion of this module, the participant will be able to:\r\n</p>\r\n<ul>\r\n    <li>Define adverse drug events and list four types.</li>\r\n    <li>Distinguish the severity level of adverse drug reactions.</li>\r\n    <li>Recognize when to report drug reactions to the appropriate healthcare practitioner.</li>\r\n    <li>Recognize when to report drug reactions to MedWatch.</li>\r\n    <li>Identify populations at greatest risk of adverse drug events.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D8CF904-C697-EB11-80DE-005056B160AF",
                        "course_category_name": "Food & Drug Administration",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2CB1C04-8706-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Adverse Drug Events",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2E449059-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Medication Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "zRemoved-Medical Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D26135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Pharmacist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse Midwife",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "A4026D3B-BAD0-EE11-998B-005056A721AC",
                "course_version": 2,
                "name": "SQ Acute: Antibiotic Resistance (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This module reviews what happens when antibiotics do not stop germs as they should, antibiotic use, and how to protect people from antibiotic resistance.",
                "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Recognize the infection prevention and control requirements and antibiotic stewardship Conditions of Participation (CoP).</li>\r\n    <li>Identify three actions that healthcare providers can take to protect individuals in their care and people in their community from antibiotic-resistant infections.\r\n    </li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "zRemoved-Medical Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2E449059-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Medication Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9996B0CC-BF26-EC11-80E8-005056B135DF",
                        "course_category_name": "Competency: Antibiotic Stewardship",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D26135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Pharmacist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "0A6FF1B9-C4D0-EE11-998B-005056A721AC",
                "course_version": 2,
                "name": "SQ Acute: Infection, Transmission-Based Precautions (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This module provides an overview of strategies and controls designed to prevent the healthcare-associated transmission of pathogens by the contact, droplet, and airborne routes.",
                "learning_objectives_html": "Upon completion of this module, participant will be able to:\r\n<ul>\r\n    <li>\r\n    Identify common pathogens that require transmission-based precautions. </li>\r\n    <li>\r\n    Identify ways to prevent infections from being transmitted by contact, droplet, and airborne routes.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "zRemoved-Medical Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F52D6401-D18C-EB11-80DF-005056B134EC",
                        "course_category_name": "Airborne, Droplet, and Isolation Precautions",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5F3A8743-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Infection Control and Prevention",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BD9F31D2-8506-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Transmission-Based Precautions",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                        "course_category_name": "zRemoved-Cardiovascular Perfusionist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "A653B162-C5D0-EE11-998B-005056A721AC",
                "course_version": 2,
                "name": "SQ Acute: Medication Management, Clinical (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This module reviews ordering, scheduling, and identifying medications. It will also identify best practices for preparing and administering medications along with the documentation requirements needed.",
                "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Identify safe practices for medication administration.</li>\r\n    <li>Distinguish the risks related to medication management.</li>\r\n    <li>Describe documentation requirements related to medication administration and  monitoring.\r\n    </li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "zRemoved-Medical Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8C02850F-CC8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Medication Administration",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2E449059-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Medication Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                        "course_category_name": "zRemoved-Cardiovascular Perfusionist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5189FB23-8706-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Medication Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "D0A935FB-C6D0-EE11-998B-005056A721AC",
                "course_version": 2,
                "name": "SQ Acute: Medications, Interactions (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This module covers causes and types of common medication interactions. It emphasizes the important role of the pharmacist and describes actions to reduce the risk of an adverse medication event. Taking more than one medication increases the risk because medications can interact with each other and either increase or decrease the effects or cause side effects.",
                "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Identify causes of drug-drug interactions.</li>\r\n    <li>\r\n    Identify types of medication interactions.</li>\r\n    <li>\r\n    Recognize the role of the pharmacist related to safe medication practices.</li>\r\n    <li>\r\n    Describe best practices to prevent medication interactions.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "zRemoved-Medical Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8C02850F-CC8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Medication Administration",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2E449059-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Medication Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                        "course_category_name": "zRemoved-Cardiovascular Perfusionist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0B2A2D13-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Injury Prevention",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5189FB23-8706-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Medication Management",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "ED9F03BD-BBD0-EE11-998B-005056A721AC",
                "course_version": 4,
                "name": "SQ Acute: Anticoagulant Therapy and Risk Reduction (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This module discusses types of anticoagulant therapy, common errors and risks, and preventive strategies to improve safety.",
                "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    List the most common uses for anticoagulant therapy.</li>\r\n    <li>\r\n    Recognize why anticoagulant therapy is a risk-laden treatment.</li>\r\n    <li>\r\n    Distinguish types of anticoagulants commonly used today.</li>\r\n    <li>\r\n    Recognize common errors related to anticoagulant therapy.</li>\r\n    <li>\r\n    Describe the goals and necessary components of patient education regarding anticoagulant therapy.</li>\r\n    <li>\r\n    Identify best practices when using anticoagulant therapy.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "441538F6-8606-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Anticoagulant Therapy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "zRemoved-Medical Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D26135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Pharmacist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "8B02B9D7-C5D0-EE11-998B-005056A721AC",
                "course_version": 3,
                "name": "SQ Acute: Medications, Hazardous (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This module discusses the characteristics of hazardous medications. It will identify potential risks and best practices during preparation, administration, care, and disposal. This will also review the importance of medical surveillance.",
                "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Identify characteristics of hazardous medications and how they can cause harm.</li>\r\n    <li>\r\n    Identify potential exposure risks in each step of medication handling and use.</li>\r\n    <li>\r\n    Locate credible resources for hazardous medication handling.</li>\r\n    <li>\r\n    Describe best practices to prevent exposure to hazardous medications\r\n    during preparation administration, patient care, and disposal.</li>\r\n    <li>\r\n    Describe the requirement for medical surveillance when handling hazardous medications routinely.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "zRemoved-Medical Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "830AFE10-8706-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: High Risk Medications",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DC261434-EBF9-E611-AF66-005056B104B1",
                        "course_category_name": "Oncologic Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0B2A2D13-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Injury Prevention",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                        "course_category_name": "zRemoved-Cardiovascular Perfusionist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8C02850F-CC8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Medication Administration",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2E449059-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Medication Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "6ABA8BBA-CDD0-EE11-998B-005056A721AC",
                "course_version": 2,
                "name": "SQ Acute: Patient Rights, Advance Directives (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This module describes advance directives and provides an overview of different types and how the directives differ from advance orders. The module also discusses legal requirements and healthcare provider roles.",
                "learning_objectives_html": "Upon completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>Define and describe types of advance directives.\r\n    </li>\r\n    <li>    Distinguish advance directives from advance orders.\r\n    </li>\r\n    <li>    Describe a healthcare professional&rsquo;s role related to advance directives.\r\n    </li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "zRemoved-Medical Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "31CED46F-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Rights and Responsibilities",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F7C5BD13-9206-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Advance Directives",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "64AC0E63-34D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Patient Advocacy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7D62C2A1-136D-E911-9E21-005056B13721",
                        "course_category_name": "Conditions of Participation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D26135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Pharmacist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "98A79B9E-B6D0-EE11-998B-005056A721AC",
                "course_version": 4,
                "name": "SQ Acute: Abduction, Infant and Child (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This module reviews the root causes of infant and child abductions, a healthcare worker's role in preventing them, and the best practices for keeping infants and children safe in a facility.",
                "learning_objectives_html": "Upon completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Describe the characteristics&nbsp;of an abductor.\u202f </li>\r\n    <li>\r\n    Identify best practices for preventing abduction.\u202f </li>\r\n    <li>\r\n    State\u202fwhat\u202ffamily education will help prevent abduction.\u202f </li>\r\n    <li>\r\n    State what staff education will help prevent abduction.\u202f </li>\r\n    <li>\r\n    Describe\u202fthe appropriate staff response to an attempted or actual abduction.<br class=\"t-last-br\" />\r\n    </li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D0F18666-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Patient or Resident Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                        "course_category_name": "zRemoved-Cardiovascular Perfusionist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "122F6D1F-C126-EC11-80E8-005056B135DF",
                        "course_category_name": "Competency: Patient or Resident Security",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "zRemoved-Medical Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9E2202A8-0386-E811-ABAD-005056B17F80",
                        "course_category_name": "School",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "64AC0E63-34D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Patient Advocacy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "14BB9F58-BDD0-EE11-998B-005056A721AC",
                "course_version": 6,
                "name": "SQ Acute: Care Delivery, Culturally Competent (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This module describes what culture means and how care that is sensitive to culture provides the best medical outcomes. Unequal and unfair treatment causes harm, and cultural sensitivity promotes fair medical treatment to reduce risk of harm.",
                "learning_objectives_html": "Upon completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Define culture.</li>\r\n    <li>\r\n    List three outcomes of fair and equal treatment that is sensitive to culture. </li>\r\n    <li>\r\n    List three outcomes of unfair and unequal treatment that is not sensitive to culture.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C4C69461-2D0C-EC11-80E5-005056B16B79",
                        "course_category_name": "Competency: Cultural Competency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "zRemoved-Medical Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "ADFB6B18-D5C9-E511-82AF-005056B150D3",
                        "course_category_name": "Cultural Awareness",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                        "course_category_name": "zRemoved-Cardiovascular Perfusionist",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "1A738077-BED0-EE11-998B-005056A721AC",
                "course_version": 3,
                "name": "SQ Acute: COVID-19 Emergency Temporary Standard (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Kathleen Greene-Batt",
                "description": "This module reviews the OSHA Emergency Temporary Standard. It has been updated to include information based on changes made since the end of the federal Public Health Emergency was declared.",
                "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>List three ways that COVID-19 is transmitted.</li>\r\n    <li>Identify signs and symptoms of COVID-19.</li>\r\n    <li>Identify required protective measures to take when working with suspected or confirmed cases of COVID-19.\r\n    </li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C74C5EEC-1C42-11DD-8EF5-001517135513",
                        "course_category_name": "Disaster Planning",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F52D6401-D18C-EB11-80DF-005056B134EC",
                        "course_category_name": "Airborne, Droplet, and Isolation Precautions",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "zRemoved-Medical Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E4265595-BE26-EC11-80E8-005056B135DF",
                        "course_category_name": "Competency: COVID-Related",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0B2A2D13-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Injury Prevention",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                        "course_category_name": "zRemoved-Cardiovascular Perfusionist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "4F988808-C2D0-EE11-998B-005056A721AC",
                "course_version": 4,
                "name": "SQ Acute: Ergonomics and Safe Lifting, Clinical (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This module defines ergonomics and gives examples of where and how ergonomics can be applied in the workplace. Musculoskeletal disorders (MSDs) are explained and suggestions are made about how to prevent back pain and injury using ergonomic tools and equipment. The module also reviews three primary risk factors for injury during physical tasks, proper body mechanics for manual lifting, when to use mechanical equipment or assistive devices, and gives examples of lifting equipment and assistive devices. This module content is designed for clinical personnel.",
                "learning_objectives_html": "Upon completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Describe the principles of ergonomics and their applications.\r\n    </li>\r\n    <li>    Describe risk factors that increase the risk of musculoskeletal disorders (MSDs).\r\n    </li>\r\n    <li>    Identify measures that healthcare workers can take to reduce risk of injury to oneself or the person being moved.\r\n    </li>\r\n    <li>    Explain why the basic principles of lifting an object do not apply well to lifting or moving people.</li>\r\n    <li>Describe how to determine if a transfer device is needed.\r\n    </li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6D11B708-6F06-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Ergonomics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D04DB9A7-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Workflow Efficiency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "09A3C12D-D505-EC11-80E5-005056B107A8",
                        "course_category_name": "Risk Area: Employee Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "zRemoved-Medical Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6429BC8C-6F00-E711-9B94-005056B141CC",
                        "course_category_name": "Workforce Culture",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                        "course_category_name": "zRemoved-Cardiovascular Perfusionist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0B2A2D13-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Injury Prevention",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "2BD8F2C8-C2D0-EE11-998B-005056A721AC",
                "course_version": 4,
                "name": "SQ Acute: Fire Safety (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This module reviews the basics of fire safety, how to respond to a fire in a facility, and how to prevent fires from happening.",
                "learning_objectives_html": "Upon completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>Describe required safety features and other methods to prevent, suppress, and extinguish fires.</li>\r\n    <li>Identify OSHA and CMS regulations for fire safety.\r\n    </li>\r\n    <li>    Recognize risk factors for fire related to the fire triangle. </li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DE9EE97E-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0B2A2D13-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Injury Prevention",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "98B27526-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Electrical Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "zRemoved-Medical Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C4246662-9206-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Fire Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                        "course_category_name": "zRemoved-Cardiovascular Perfusionist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "64D94663-C3D0-EE11-998B-005056A721AC",
                "course_version": 3,
                "name": "SQ Acute: Hazard Communication (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This module explains how OSHA's Hazard Communication Standard (HCS) classifies a chemical as a physical hazard or a health hazard and reviews specific PPE that should be used when working near or with hazardous chemicals. The module also explains in detail what must be on a label, including explanations of the nine pictograms, as well as the sixteen components of a safety data sheet (SDS).",
                "learning_objectives_html": "Upon completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Identify types of chemical hazards in the healthcare setting.\r\n    </li>\r\n    <li>    Discuss protective measures used when working with hazardous chemicals.\r\n    </li>\r\n    <li>    Recognize three common chemical hazards in hospitals: Formaldehyde , Glutaraldehyde, and Ethylene Oxide.\r\n    </li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "zRemoved-Medical Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF2C23AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Effective Communication",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DE9EE97E-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5559DC85-9206-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Hazard Communication",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                        "course_category_name": "zRemoved-Cardiovascular Perfusionist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "10E18C74-C6D0-EE11-998B-005056A721AC",
                "course_version": 2,
                "name": "SQ Acute: Medications, High-Alert (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "According to the\u00a0Institute for Safe Medication Practices (ISMP), high-alert medications are those that have an increased risk of causing significant patient harm when used in error.\u00a0This module will review some important information on the ISMP list and best practices when managing patients receiving high-alert medications.",
                "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Give examples of the most common high-alert medication classes.</li>\r\n    <li>\r\n    Identify recommended strategies for protecting individuals from adverse drug events. </li>\r\n    <li>\r\n    Recognize the appropriate response to a medication error.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "C2068A6B-F3FD-E611-BC44-005056B10E33",
                        "course_category_name": "Diabetic Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "830AFE10-8706-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: High Risk Medications",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8C02850F-CC8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Medication Administration",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2E449059-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Medication Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0B2A2D13-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Injury Prevention",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "37655999-C7D0-EE11-998B-005056A721AC",
                "course_version": 4,
                "name": "SQ Acute: Medications, Preventing Rehospitalization (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This module will identify medication groups that may increase risk of rehospitalizations and emergency department visits from adverse drug events (ADE). The module will also discuss best practices to help decrease or prevent hospital visits due to ADEs.",
                "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Identify medication groups known to increase risk for emergency department visits and hospitalizations.</li>\r\n    <li>\r\n    Describe clinical considerations and best practices when individuals require certain medications. </li>\r\n    <li>\r\n    Describe the role of professional responsibility in decreasing emergency room visits and hospitalizations in relation to ADEs.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D0F18666-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Patient or Resident Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0B2A2D13-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Injury Prevention",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "01265A0C-C126-EC11-80E8-005056B135DF",
                        "course_category_name": "Competency: Discharge Planning",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "zRemoved-Medical Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                        "course_category_name": "zRemoved-Cardiovascular Perfusionist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "3827D9B3-CBD0-EE11-998B-005056A721AC",
                "course_version": 4,
                "name": "SQ Acute: National Performance Goals (NPGs), Basics (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Carleigh Davis",
                "description": "This learning activity reviews the Joint Commission's National Performance Goals (NPGs). It will review important details of each of the 14 NPGs goals.",
                "learning_objectives_html": "Upon completion of this learning activity, the participant will be able to:\r\n<ul>\r\n    <li>Identify the national performance goals (NPGs).</li>\r\n    <li>Indicate the importance, purpose, and significance of each NPG.</li>\r\n    <li>Recognize how healthcare professionals can support each goal.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "7064D866-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "29A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C5D2C33F-369B-EC11-80ED-005056B1202E",
                        "course_category_name": "Competency: Performance Improvement",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0A2A275A-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D0F18666-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Patient or Resident Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C6B37F61-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Rehabilitation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "05DBEBFD-CED0-EE11-998B-005056A721AC",
                "course_version": 3,
                "name": "SQ Acute: Restraint and Seclusion (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This module reviews the basics of restraints and the risks associated with restraints and seclusion. The CMS Conditions of Participation guidelines for the use of restraints and seclusion are discussed.",
                "learning_objectives_html": "Upon completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Describe required elements of the Restraint and Seclusion Conditions of Participation.\r\n    </li>\r\n    <li>    Identify potential risks when using both physical and chemical restraint.\r\n    </li>\r\n    <li>    Identify early intervention strategies to prevent or mitigate challenging behaviors.\r\n    </li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "31CED46F-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Rights and Responsibilities",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "zRemoved-Medical Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0B2A2D13-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Injury Prevention",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DF0AFF1A-9206-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Restraints and Seclusion",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                        "course_category_name": "zRemoved-Cardiovascular Perfusionist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "B95F92F6-C3D0-EE11-998B-005056A721AC",
                "course_version": 3,
                "name": "SQ Acute: Infection, Healthcare-Associated, Clinical (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This module covers infection control and antibiotic stewardship in healthcare, and reviews reportable infections and how to protect individuals from them. This module will also discuss healthcare-associated infections that are of urgent concern. This content is designed for clinical personnel.",
                "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Identify the characteristics of effective Infection Control and Antibiotic Stewardship Programs.\r\n    </li>\r\n    <li>    Identify several resistant pathogens that seriously threaten healthcare.\r\n    </li>\r\n    <li>    Identify actions that healthcare professionals can take to protect patients and stop outbreaks from resistant pathogens.\r\n    </li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9FEBCF0-CC8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Personal Protective Equipment",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F52D6401-D18C-EB11-80DF-005056B134EC",
                        "course_category_name": "Airborne, Droplet, and Isolation Precautions",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5F3A8743-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Infection Control and Prevention",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                        "course_category_name": "zRemoved-Cardiovascular Perfusionist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "085322BE-8506-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Healthcare-Associated Infections",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "zRemoved-Medical Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "80A91C76-CED0-EE11-998B-005056A721AC",
                "course_version": 5,
                "name": "SQ Acute: Patient Rights, Clinical (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This module emphasizes the importance of understanding and respecting patient rights. It includes the list of patient rights from the Conditions of Participation (CoP) for hospitals. This content is intended for clinical personnel.",
                "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Identify the patient's rights under the conditions of participation for hospitals.</li>\r\n    <li>\r\n    Recognize a healthcare professional's responsibilities regarding patient rights.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "64AC0E63-34D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Patient Advocacy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2115A6DC-9106-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Patient Rights",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "zRemoved-Medical Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "31CED46F-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Rights and Responsibilities",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                        "course_category_name": "zRemoved-Cardiovascular Perfusionist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "E44356A7-15D0-EE11-9987-005056A7DAD4",
                "course_version": 5,
                "name": "CQ State: Preventing Sexual Harassment for Bystanders, Chicago (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Kathleen Greene-Batt",
                "description": "This learning activity covers the training requirements for employees in Chicago regarding bystander intervention when faced with sexual harassment. It defines sexual harassment and includes examples; reviews the options available for filing a complaint of sexual harassment; includes laws specific to Chicago; and explains bystander intervention and how a person can safely intervene when they witness sexual harassment. \r\n\r\nThis course is intended to assist Customers and Users with understanding and addressing minimum training requirements for all care settings in Chicago, Il for this topic. The content provided does not constitute legal or clinical advice and does not guarantee compliance with all applicable federal and state laws and regulations. This course may also satisfy training requirements for other settings in various states; however, no representation or warranty is made as to its applicability. Customers remain solely responsible for ensuring that their training programs comply with all requirements established by their relevant governing entities and that individual care is customized by and aligned with provider orders and facility policies and procedures.",
                "learning_objectives_html": "Upon the completion of this learning activity, the participant will be able to:\r\n<ul>\r\n    <li>Recognize sexual harassment.</li>\r\n    <li>Recognize situations and conditions of potential sexual harassment.</li>\r\n    <li>Identify safe and effective intervention options if sexual harassment is witnessed.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "All Disciplines",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "473D6AB7-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream ComplyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9CBA98F-C688-F011-999D-005056A7F5E9",
                        "course_category_name": "_ComplyQ: State",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB3723AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Sexual Harassment Prevention",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EC0FB4EC-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "State Sexual Harassment Training",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "00439C6C-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "47413AC4-5130-EC11-80E8-005056B16B79",
                        "course_category_name": "Competency: Sexual Harassment",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B1A43098-5130-EC11-80E8-005056B16B79",
                        "course_category_name": "Risk Area: Harassment Laws",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "3AFAD70D-1DD0-EE11-9987-005056A7DAD4",
                "course_version": 6,
                "name": "SQ Acute: Bloodborne Pathogens and Standard Precautions, Clinical (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This module reviews how to protect yourself, coworkers, patients, and family from bloodborne pathogens. Discussion is included on bloodborne pathogens found in the blood and body fluids and how\u00a0they\u00a0spread, as well as Standard Precautions\u00a0to\u00a0prevent the spread of these pathogens.\u00a0The content in this module is designed for clinical personnel.",
                "learning_objectives_html": "Upon completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>Identify bloodborne pathogens risks to healthcare workers and the individuals they care for.\r\n    </li>\r\n    <li>    Describe protective measures to minimize exposure risk\r\n    </li>\r\n    <li>    Discuss the appropriate actions to take in the event of exposure to a bloodborne pathogen&nbsp; &nbsp; &nbsp;</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5F3A8743-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Infection Control and Prevention",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CED83BE-FF85-E811-AD45-005056B16A47",
                        "course_category_name": "Occupational Safety & Health Administration",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "zRemoved-Medical Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "848116E6-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Annual Training",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B0B50CB8-8506-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Bloodborne Pathogens",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                        "course_category_name": "zRemoved-Cardiovascular Perfusionist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4FF3BFFA-D08C-EB11-80DF-005056B134EC",
                        "course_category_name": "Bloodborne Pathogens",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "5257BDEB-2AD0-EE11-9987-005056A7DAD4",
                "course_version": 2,
                "name": "CQ Acute: HIPAA, Security Rule (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Jen Bailey McKinney, MBA",
                "description": "This module provides an overview of the HIPAA Security Rule. It includes a review of how to protect electronic protected health information (ePHI), behaviors and situations that put ePHI at risk, the safeguards and requirements of the Security Rule, and reporting possible violations.",
                "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Distinguish the HIPAA Privacy Rule from the HIPAA Security Rule.</li>\r\n    <li>\r\n    Identify common behaviors and situations that put PHI at risk for unintended disclosure.</li>\r\n    <li>\r\n    Identify external risks to PHI.</li>\r\n    <li>\r\n    Identify best practices and required safeguards organizations must\r\n    take to ensure appropriate protection of electronic protected health\r\n    information.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "473D6AB7-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream ComplyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "00439C6C-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D9332047-F47A-ED11-80FB-005056B17014",
                        "course_category_name": "_ComplyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "752F23AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "HIPAA",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "All Disciplines",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "26C04B86-AF06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Privacy and Security",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69E799A8-FB16-EC11-80E5-005056B108B1",
                        "course_category_name": "Competency: HIPAA",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "622D5A09-2CD0-EE11-9987-005056A7DAD4",
                "course_version": 2,
                "name": "CQ Acute: HIPAA, Violations and Penalties (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Tasha Deitschman, MSN, RN, CPPS",
                "description": "This module will provide an overview of the HIPAA Privacy Rule\u2019s disclosure violations as well as the associated penalties. It will define and discuss examples of breaches of protected health information (PHI) as well as review commonly occurring HIPAA compliance issues.",
                "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Define a breach of protected health information (PHI). </li>\r\n    <li>\r\n    Describe and give an example of an exemption to a breach of PHI.</li>\r\n    <li>\r\n    Describe three types of Privacy disclosure violations and give examples of each.</li>\r\n    <li>\r\n    Recognize commonly occurring HIPAA compliance issues. </li>\r\n    <li>\r\n    Describe the civil and criminal penalties associated with HIPAA violations.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "All Disciplines",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69E799A8-FB16-EC11-80E5-005056B108B1",
                        "course_category_name": "Competency: HIPAA",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "26C04B86-AF06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Privacy and Security",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "473D6AB7-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream ComplyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "00439C6C-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "752F23AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "HIPAA",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D9332047-F47A-ED11-80FB-005056B17014",
                        "course_category_name": "_ComplyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "BF324D06-1AD0-EE11-9987-005056A7DAD4",
                "course_version": 3,
                "name": "SQ Acute: Suicide Risks and Prevention (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This module reviews the risk factors and warning signs of a suicidal patient. It suggests what a healthcare worker can do to help prevent a person from committing suicide. It also offers information on resources for the patient, family, and healthcare worker.",
                "learning_objectives_html": "Upon completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Identify individuals who are at risk for self-harm.\r\n    </li>\r\n    <li>    Recognize environmental safety risks for those at risk for self-harm.\r\n    </li>\r\n    <li>    Describe safety interventions for those at risk for self-harm for individuals on non-psychiatric units.\r\n    </li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "zRemoved-Medical Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "848116E6-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Annual Training",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Professional Development",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0B2A2D13-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Injury Prevention",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D0F18666-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Patient or Resident Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                        "course_category_name": "zRemoved-Cardiovascular Perfusionist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A9A5001-8806-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Suicide Prevention",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "52BA5D27-1BD0-EE11-9987-005056A7DAD4",
                "course_version": 2,
                "name": "SQ Acute: Infection, Emerging (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This module provides an overview of emerging infections. It includes a review of factors that influence the emergence of new pathogens and examples of recent emergent infections. This module also discusses how staff can prepare and learn about new emerging infections.",
                "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Define emerging infections. </li>\r\n    <li>\r\n    Describe factors that influence the emergence of new and evolving pathogens.  </li>\r\n    <li>\r\n    Recognize several emergent infections which have occurred over the last 50 years and discuss their impact.  </li>\r\n    <li>\r\n    Discuss emergency preparedness regulations in relation to emerging infectious diseases. </li>\r\n    <li>\r\n    Identify where and how clinicians and other healthcare workers can learn about emerging health threats.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "848116E6-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Annual Training",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BC8209E9-BE26-EC11-80E8-005056B135DF",
                        "course_category_name": "Competency: Infectious Diseases",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F52D6401-D18C-EB11-80DF-005056B134EC",
                        "course_category_name": "Airborne, Droplet, and Isolation Precautions",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9FEBCF0-CC8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Personal Protective Equipment",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                        "course_category_name": "zRemoved-Cardiovascular Perfusionist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7D62C2A1-136D-E911-9E21-005056B13721",
                        "course_category_name": "Conditions of Participation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "zRemoved-Medical Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "B6E27C67-1CD0-EE11-9987-005056A7DAD4",
                "course_version": 2,
                "name": "SQ Acute: Emergency Preparedness (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This module provides an overview of an emergency preparedness program, including the structure of a program and why emerging infectious diseases should be considered. The module will also discuss staff roles and training in response to an emergency.",
                "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Describe an emergency preparedness program.\r\n    </li>\r\n    <li>    Explain the importance of including emerging infectious diseases in the hazard assessment and planning for these situations.\r\n    </li>\r\n    <li>    Describe staff responsibilities during an emergency.\r\n    </li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "848116E6-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Annual Training",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "zRemoved-Medical Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "068B2671-9206-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Emergency Preparedness",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C74C5EEC-1C42-11DD-8EF5-001517135513",
                        "course_category_name": "Disaster Planning",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                        "course_category_name": "zRemoved-Cardiovascular Perfusionist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DE9EE97E-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Workplace Safety",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "3275577D-25D0-EE11-9987-005056A7DAD4",
                "course_version": 2,
                "name": "CQ Acute: Anti-Kickback Statute (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Barbara Boyne, MBA, BSN, RN",
                "description": "This module is about the Anti-Kickback Statute and the impact of kickbacks on healthcare. It will cover the reporting process and penalties for violations.",
                "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>Identify key components of the Anti-Kickback Statute.</li>\r\n    <li>Recognize the process for reporting known or suspected violations of the Anti-Kickback Statute.</li>\r\n    <li>Identify potential penalties for violating the Anti-Kickback Statute.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "00439C6C-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "49650B70-AF06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Laws, Acts and Ethics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CD580EB3-AF06-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Anti-Kickback Statute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D9332047-F47A-ED11-80FB-005056B17014",
                        "course_category_name": "_ComplyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0A2A275A-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "473D6AB7-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream ComplyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "3592490B-28D0-EE11-9987-005056A7DAD4",
                "course_version": 2,
                "name": "CQ Acute: False Claims Act (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Jackie Luchsinger, PhD, MBA, MS, RN, PMP",
                "description": "This module reviews the prohibitions of the False Claims Act (FCA) and provides examples of false claims for the learner to consider. A review of reporting processes includes the qui tam provision. The module concludes with a description of potential penalties for FCA violations.",
                "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Discuss the purpose and benefit of the False Claims Act (FCA).\r\n    </li>\r\n    <li>\r\n    Recognize the basic prohibition of the FCA.\r\n    </li>\r\n    <li>\r\n    Give examples of false claim types.\r\n    </li>\r\n    <li>\r\n    Identify the proper reporting process related to identification of potentially false claims including the qui tam provision.\r\n    </li>\r\n    <li>\r\n    Describe the potential penalties for submission of false claims.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "49650B70-AF06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Laws, Acts and Ethics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "74CF89D7-E318-E511-8B3B-005056B12CFE",
                        "course_category_name": "zRemoved-Financial Manager",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "00439C6C-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "29A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3E45E8CD-1A45-E511-98BC-005056B10E33",
                        "course_category_name": "Billing",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D9332047-F47A-ED11-80FB-005056B17014",
                        "course_category_name": "_ComplyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E3F830C8-AF06-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: False Claims Act",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "473D6AB7-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream ComplyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D9783EB6-17C9-E511-8771-005056B104B1",
                        "course_category_name": "zRemoved-Financial Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "CD6565DC-28D0-EE11-9987-005056A7DAD4",
                "course_version": 2,
                "name": "CQ Acute: Fraud, Waste, and Abuse (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Jen Bailey McKinney, MBA",
                "description": "This module is about laws and regulations related to\u00a0fraud, waste, and abuse.\u00a0Compliance programs, penalties, and reporting are also covered.",
                "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Define fraud, waste, and abuse. </li>\r\n    <li>\r\n    Identify laws that help prevent fraud, waste, and abuse. </li>\r\n    <li>\r\n    Recognize types of penalties for violation of fraud, waste, and abuse laws. </li>\r\n    <li>\r\n    Describe how to report suspected violation of fraud, waste, and abuse laws. </li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3E45E8CD-1A45-E511-98BC-005056B10E33",
                        "course_category_name": "Billing",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D9332047-F47A-ED11-80FB-005056B17014",
                        "course_category_name": "_ComplyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AEEDCE4B-DBF9-E611-AF66-005056B104B1",
                        "course_category_name": "Healthcare Business",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "74CF89D7-E318-E511-8B3B-005056B12CFE",
                        "course_category_name": "zRemoved-Financial Manager",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "473D6AB7-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream ComplyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9F4A29D6-AF06-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Fraud, Waste & Abuse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B3283CD0-D5C9-E511-82AF-005056B150D3",
                        "course_category_name": "Healthcare and Governance",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DF2C23AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Coding and Billing Compliance",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "29A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "49650B70-AF06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Laws, Acts and Ethics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D9783EB6-17C9-E511-8771-005056B104B1",
                        "course_category_name": "zRemoved-Financial Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "00439C6C-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "51E3B198-1AD0-EE11-9987-005056A7DAD4",
                "course_version": 6,
                "name": "SQ Acute: Infection, Tuberculosis (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "Tuberculosis control depends on prevention and treatment. This module reviews the causes of TB, risk factors, symptoms, transmission, and prevention of tuberculosis.",
                "learning_objectives_html": "Upon completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Describe tuberculosis (TB) transmission.\r\n    </li>\r\n    <li>    Describe risk factors for TB infection.\r\n    </li>\r\n    <li>    Describe measures to prevent TB.\r\n    </li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "848116E6-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Annual Training",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                        "course_category_name": "zRemoved-Cardiovascular Perfusionist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5F3A8743-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Infection Control and Prevention",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F52D6401-D18C-EB11-80DF-005056B134EC",
                        "course_category_name": "Airborne, Droplet, and Isolation Precautions",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "zRemoved-Medical Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BC8209E9-BE26-EC11-80E8-005056B135DF",
                        "course_category_name": "Competency: Infectious Diseases",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "57ADBACD-1BD0-EE11-9987-005056A7DAD4",
                "course_version": 3,
                "name": "SQ Acute: Fire Safety, Fire Extinguisher Use (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This module provides an overview of the different types of fire extinguishers and how to properly use them to help save lives and limit property damage in the event of a fire.",
                "learning_objectives_html": "Upon completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Identify the different types of fire extinguishers.</li>\r\n    <li>Recognize the acronym PASS and its use. </li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                        "course_category_name": "zRemoved-Cardiovascular Perfusionist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0B2A2D13-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Injury Prevention",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "zRemoved-Medical Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "848116E6-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Annual Training",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C4246662-9206-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Fire Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DE9EE97E-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8985BD40-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Device Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "AFEE64C0-26D0-EE11-9987-005056A7DAD4",
                "course_version": 1,
                "name": "CQ Acute: Documentation for Practitioners, Evaluation and Management (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Tasha Deitschman, MSN, RN, CPPS",
                "description": "This module reviews the elements of necessary documentation for proper evaluation and management (E/M) coding. Learners will review the components of medical decision-making, code sets and their purpose, and descriptors that help code accurately.",
                "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Recognize elements of documentation that help to select proper E/M coding.</li>\r\n    <li>Describe components of medical decision-making.</li>\r\n    <li>Describe the various code sets and their purpose.</li>\r\n    <li>Give several examples of condition descriptions that help coding accurately.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "473D6AB7-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream ComplyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "ECB515FE-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "Competency: Documentation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0A2A275A-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D9332047-F47A-ED11-80FB-005056B17014",
                        "course_category_name": "_ComplyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3E45E8CD-1A45-E511-98BC-005056B10E33",
                        "course_category_name": "Billing",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "00439C6C-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2CCAD5F5-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "Risk Area: Documentation, Billing and Contracts",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "2810AD61-27D0-EE11-9987-005056A7DAD4",
                "course_version": 2,
                "name": "CQ Acute: Documentation for Practitioners, Overview (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Tasha Deitschman, MSN, RN, CPPS",
                "description": "This module provides an overview of documentation for providers. It will review the rationale for accurate medical record documentation, required elements, and documentation needed to justify a hospital admission and continued inpatient stay. It will also review common documentation errors.",
                "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>Describe the rationale for accurate medical record documentation by practitioners.</li>\r\n    <li>Recognize required content of the medical record.</li>\r\n    <li>Recognize common documentation errors that contribute to poor staff communication and payment denials.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3E45E8CD-1A45-E511-98BC-005056B10E33",
                        "course_category_name": "Billing",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "ECB515FE-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "Competency: Documentation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2CCAD5F5-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "Risk Area: Documentation, Billing and Contracts",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "00439C6C-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D9332047-F47A-ED11-80FB-005056B17014",
                        "course_category_name": "_ComplyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0A2A275A-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "473D6AB7-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream ComplyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "4CFFFC1D-2AD0-EE11-9987-005056A7DAD4",
                "course_version": 4,
                "name": "CQ Acute: HIPAA, Privacy Rule (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Jackie Luchsinger, PhD, MBA, MS, RN, PMP",
                "description": "This module provides an overview of the HIPAA Privacy Rule. The module discusses the basic components of the Privacy Rule, including general information and principles on handling protected health information (PHI), an overview of patient rights, general administrative safeguards that protect PHI, an overview of extreme risk protection orders (ERPOs), and how to handle breaches to PHI.",
                "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>Describe the basic provisions of the Privacy Rule under HIPAA.</li>\r\n    <li>Recognize the requirements and components of the Notice of Privacy Practices.</li>\r\n    <li>Describe the Breach Notification Rule.\r\n    </li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "752F23AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "HIPAA",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "473D6AB7-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream ComplyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "26C04B86-AF06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Privacy and Security",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69E799A8-FB16-EC11-80E5-005056B108B1",
                        "course_category_name": "Competency: HIPAA",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D9332047-F47A-ED11-80FB-005056B17014",
                        "course_category_name": "_ComplyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "00439C6C-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "All Disciplines",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "989A776D-2DD0-EE11-9987-005056A7DAD4",
                "course_version": 2,
                "name": "CQ Acute: Stark Law (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Barbara Boyne, MBA, BSN, RN",
                "description": "This module describes the Stark Law and its prohibitions, purpose, and penalties for violations. It also reviews recent changes to the law.",
                "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>Recognize the Stark Law (Physician Referral Law) and its purpose.</li>\r\n    <li>Describe penalties for violations of the Stark Law.</li>\r\n    <li>Explain how to report a violation of Stark.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "473D6AB7-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream ComplyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FF7753DC-AF06-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Stark Law",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "00439C6C-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D9332047-F47A-ED11-80FB-005056B17014",
                        "course_category_name": "_ComplyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "49650B70-AF06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Laws, Acts and Ethics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "358D41B7-13D0-EE11-9987-005056A7DAD4",
                "course_version": 4,
                "name": "CQ State: Preventing Sexual Harassment, Illinois (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Tasha Deitschman, MSN, RN, CPPS",
                "description": "This learning activity will review employee discrimination protections under Illinois law. It will define sexual harassment and the different types under Illinois law, review workplace prevention strategies, and identify actions for people to take if they experience sexual harassment. It will also review manager responsibilities related to sexual harassment.\r\n\r\nThis course is intended to assist Customers and Users with understanding and addressing minimum training requirements for all care settings in Illinois for this topic. The content provided does not constitute legal or clinical advice and does not guarantee compliance with all applicable federal and state laws and regulations. This course may also satisfy training requirements for other settings in various states; however, no representation or warranty is made as to its applicability. Customers remain solely responsible for ensuring that their training programs comply with all requirements established by their relevant governing entities and that individual care is customized by and aligned with provider orders and facility policies and procedures.",
                "learning_objectives_html": "Upon the completion of this learning activity, the participant will be able to:\r\n<ul>\r\n    <li>Describe discrimination protections afforded to individuals under Federal and Illinois law.</li>\r\n    <li>Define sexual harassment under Illinois law.</li>\r\n    <li>Recognize strategies to prevent sexual harassment in the workplace.</li>\r\n    <li>Identify actions to take for a person affected by sexual harassment.</li>\r\n    <li>Specify employer obligations regarding sexual harassment.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "473D6AB7-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream ComplyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "All Disciplines",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B1A43098-5130-EC11-80E8-005056B16B79",
                        "course_category_name": "Risk Area: Harassment Laws",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB3723AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Sexual Harassment Prevention",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9CBA98F-C688-F011-999D-005056A7F5E9",
                        "course_category_name": "_ComplyQ: State",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "47413AC4-5130-EC11-80E8-005056B16B79",
                        "course_category_name": "Competency: Sexual Harassment",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EC0FB4EC-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "State Sexual Harassment Training",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "00439C6C-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "6E9A76FA-14D0-EE11-9987-005056A7DAD4",
                "course_version": 5,
                "name": "CQ State: Preventing Sexual Harassment for Employees, Chicago (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Kathleen Greene-Batt",
                "description": "This learning activity covers the training requirements for employees in Chicago regarding the prevention of sexual harassment, including the types and examples of sexual harassment; the importance of following the anti-sexual harassment policy; how to prevent it; the different options available for filing a claim; the illegality and examples of retaliation; and remedies available to people affected by sexual harassment.\r\n\r\nThis course is intended to assist Customers and Users with understanding and addressing minimum training requirements for all care settings in Chicago, IL for this topic. The content provided does not constitute legal or clinical advice and does not guarantee compliance with all applicable federal and state laws and regulations. This course may also satisfy training requirements for other settings in various states; however, no representation or warranty is made as to its applicability. Customers remain solely responsible for ensuring that their training programs comply with all requirements established by their relevant governing entities and that individual care is customized by and aligned with provider orders and facility policies and procedures.",
                "learning_objectives_html": "Upon the completion of this learning activity, the participant will be able to:\r\n<ul>\r\n    <li>Identify sexual harassment.</li>\r\n    <li>Recognize how to prevent and confront sexual harassment.</li>\r\n    <li>Identify federal, state, and local laws concerning sexual harassment and remedies available to people who have experienced sexual harassment.</li>\r\n    <li>Identify employer responsibilities in the prevention, investigation, and corrective measures of sexual harassment.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9CBA98F-C688-F011-999D-005056A7F5E9",
                        "course_category_name": "_ComplyQ: State",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "473D6AB7-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream ComplyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "47413AC4-5130-EC11-80E8-005056B16B79",
                        "course_category_name": "Competency: Sexual Harassment",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB3723AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Sexual Harassment Prevention",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "All Disciplines",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B1A43098-5130-EC11-80E8-005056B16B79",
                        "course_category_name": "Risk Area: Harassment Laws",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EC0FB4EC-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "State Sexual Harassment Training",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "00439C6C-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "D0A01251-19D0-EE11-9987-005056A7DAD4",
                "course_version": 6,
                "name": "SQ Acute: Workplace Violence (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This module discusses the risks and warning signs of workplace violence in healthcare and provides de-escalation tips to protect yourself and others. It also presents the elements of an effective workplace violence prevention program.",
                "learning_objectives_html": "Upon completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Recognize the risks and warning signs of violence in  the workplace.</li>\r\n    <li>\r\n    Identify de-escalation best practices. </li>\r\n    <li>\r\n    Understand the key elements of a workplace violence prevention plan.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6429BC8C-6F00-E711-9B94-005056B141CC",
                        "course_category_name": "Workforce Culture",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0B2A2D13-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Injury Prevention",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                        "course_category_name": "zRemoved-Cardiovascular Perfusionist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "zRemoved-Medical Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A337536A-C126-EC11-80E8-005056B135DF",
                        "course_category_name": "Competency: Workplace Violence",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "31CED46F-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Rights and Responsibilities",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "848116E6-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Annual Training",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD11353E-BA97-EB11-80DE-005056B160AF",
                        "course_category_name": "Occupational Stress",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "43087D1C-26D0-EE11-9987-005056A7DAD4",
                "course_version": 2,
                "name": "CQ Acute: Compliance Program (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Barbara Boyne, MBA, BSN, RN",
                "description": "This module describes the purpose and vital parts of a compliance program. It will discuss compliance risk areas in the healthcare industry and the role of healthcare workers.",
                "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>Recognize the importance and benefits of an effective compliance program.</li>\r\n    <li>Recognize potential risk areas within an organization.</li>\r\n    <li>Appreciate the need to report suspected violations, including what and who to inform.  </li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "All Disciplines",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "473D6AB7-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream ComplyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8D33B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Law and Ethics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D9332047-F47A-ED11-80FB-005056B17014",
                        "course_category_name": "_ComplyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "49650B70-AF06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Laws, Acts and Ethics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0A2A275A-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9F4A29D6-AF06-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Fraud, Waste & Abuse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "00439C6C-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "41F97B70-29D0-EE11-9987-005056A7DAD4",
                "course_version": 3,
                "name": "CQ Acute: HIPAA, Patient Rights (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Debbie Curl-Nagy, MSW, LSSMBB",
                "description": "This module reviews the Health Insurance Portability and Accountability Act (HIPAA) Privacy Rule. The purpose and elements of the Notice of Privacy Practices (NPP) are discussed as well as patient rights regarding their protected health information (PHI).",
                "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Discuss patient rights under the HIPAA Privacy Rule.</li>\r\n    <li>\r\n    List the four requirements that must be included in the Notice of Privacy Practices.</li>\r\n    <li>\r\n    Relate patient needs for privacy to their rights under the HIPAA Privacy Rule.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "00439C6C-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D9332047-F47A-ED11-80FB-005056B17014",
                        "course_category_name": "_ComplyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "26C04B86-AF06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Privacy and Security",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C033B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "HIPAA",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69E799A8-FB16-EC11-80E5-005056B108B1",
                        "course_category_name": "Competency: HIPAA",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "All Disciplines",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8D33B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Law and Ethics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "473D6AB7-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream ComplyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "944151B5-2CD0-EE11-9987-005056A7DAD4",
                "course_version": 2,
                "name": "CQ Acute: Medical Identity Theft (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Debbie Curl-Nagy, MSW, LSSMBB",
                "description": "This module provides an overview of patient and provider forms of medical identity theft. The content outlines the impact on affected people and the steps that people receiving care, providers, and healthcare organizations can take to prevent medical identity theft.",
                "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Describe medical-related identity theft.</li>\r\n    <li>\r\n    Distinguish two types of medical identity theft. </li>\r\n    <li>\r\n    Recognize motivation behind medical identity theft crimes.</li>\r\n    <li>\r\n    Identify steps that beneficiaries and their providers can take to prevent medical identity theft.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD11353E-BA97-EB11-80DE-005056B160AF",
                        "course_category_name": "Occupational Stress",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "473D6AB7-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream ComplyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8985BD40-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Device Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D4B3D925-B006-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Medical Identity Theft",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D9332047-F47A-ED11-80FB-005056B17014",
                        "course_category_name": "_ComplyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F66135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Administrators",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "00439C6C-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "6F53346C-A2CE-EF11-9996-005056A7FC7D",
                "course_version": 1,
                "name": "CQ Acute: Confidentiality of Substance Use Disorder Patient Records, 42 CFR Part 2 (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Carleigh Davis (WGContent)",
                "description": "This module covers the confidentiality of substance use disorder (SUD) patient records as mandated by 42 CFR Part 2. It explains the regulations and requirements for protecting the privacy of individuals undergoing SUD treatment, the circumstances under which information can be disclosed, and the penalties for violations.",
                "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>Define the purpose of 42 CFR Part 2.</li>\r\n    <li>Describe the requirements for substance use disorder patient records.</li>\r\n    <li>Identify the importance of maintaining patient privacy and confidentiality.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "38B21092-0F5B-EF11-998E-005056A7C0C7",
                        "course_category_name": "Competency: Confidentiality",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "56EBAE7E-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Home Healthcare",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7064D866-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "00439C6C-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "362D23AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Corporate Compliance",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "473D6AB7-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream ComplyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A5538AC7-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Residential and Long Term Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "26C04B86-AF06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Privacy and Security",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "All Disciplines",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0A2A275A-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "55C9834D-0286-E811-9579-005056B150D1",
                        "course_category_name": "Hospice",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D9332047-F47A-ED11-80FB-005056B17014",
                        "course_category_name": "_ComplyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "3A60BCE3-A0CE-EF11-9996-005056A7FC7D",
                "course_version": 1,
                "name": "CQ Acute: Texting Compliance in Healthcare, Safety and Privacy (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Carlina Scalf (WGContent)",
                "description": "This module discusses texting compliance in healthcare. It explains the uses and risks of texting in healthcare. It reviews Health Insurance Portability and Accountability Act (HIPAA)-compliant text messaging and discusses best practices for secure texting to prevent privacy violations.",
                "learning_objectives_html": "After completing this learning activity, the participant should be able to:\r\n<ul>\r\n    <li>Identify requirements of text messaging in healthcare.</li>\r\n    <li>List benefits of HIPAA compliant text messaging in healthcare.</li>\r\n    <li>Specify safeguards needed for secure text messaging to prevent privacy violations. </li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "All Disciplines",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A5538AC7-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Residential and Long Term Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "473D6AB7-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream ComplyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C17A92DE-0BEA-E511-B707-005056B16096",
                        "course_category_name": "Informatics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D9332047-F47A-ED11-80FB-005056B17014",
                        "course_category_name": "_ComplyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "00439C6C-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "29A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A4D0CAF4-0D5B-EF11-9993-005056A73D13",
                        "course_category_name": "Competency: Privacy Laws",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "752F23AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "HIPAA",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "362D23AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Corporate Compliance",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6429BC8C-6F00-E711-9B94-005056B141CC",
                        "course_category_name": "Workforce Culture",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "26C04B86-AF06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Privacy and Security",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D12F23AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Human Resources",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            }
        ]
    }
];